import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  User,
  TopMerchantsQuery,
  TopMerchantsQueryVariables
} from "../../../../schemaTypes";

export const topMerchantsQuery = gql`
  query TopMerchants($offset: Int!, $limit: Int!) {
    topMerchants(offset: $offset, limit: $limit) {
      id
      admin {
        id
        merchantProfile {
          id
          # address
          # country
          # postcode
          companyName
          username
          # industry {
          #   id
          #   name
          # }
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
      isVerified
    }
  }
`;

export interface WithTopMerchants {
  merchants: User[];
  loading: boolean;
}

interface Props {
  variables: TopMerchantsQueryVariables;
  children: (data: WithTopMerchants) => React.ReactElement | null;
}

export const TopMerchants: React.FC<Props> = ({ children, variables }) => {
  const { data, loading } = useQuery<TopMerchantsQuery, TopMerchantsQueryVariables>(
    topMerchantsQuery,
    {
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  let merchants: User[] = [];
  if (data && data.topMerchants) {
    merchants = data.topMerchants as User[];
  }

  return children({
    merchants,
    loading,
  });
};
